import React from 'react';
import { SkeletonStyled } from './skeleton.styled';
import { Variants } from './types';

interface SkeletonProps {
  variant?: keyof typeof Variants;
  width?: number | string;
  height?: number | string;
  size?: string;
  children?: React.ReactNode | React.ReactNode[];
}

const Skeleton = ({ children, ...rest }: SkeletonProps) => {
  return <SkeletonStyled {...rest}>{children}</SkeletonStyled>;
};

Skeleton.defaultProps = {
  variant: Variants.text,
  size: 'small',
};

export default Skeleton;
